import { createContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const UsageTrackerContext = /*#__PURE__*/createContext(undefined);
export function UsageTrackerProvider({
  children,
  tracker
}) {
  return /*#__PURE__*/_jsx(UsageTrackerContext.Provider, {
    value: tracker,
    children: children
  });
}
export function createMockUsageTracker({
  clone,
  getConfig,
  setProperties,
  track
}) {
  return {
    clone: clone !== null && clone !== void 0 ? clone : jasmine.createSpy('clone'),
    setProperties: setProperties !== null && setProperties !== void 0 ? setProperties : jasmine.createSpy('setProperties'),
    getConfig: getConfig !== null && getConfig !== void 0 ? getConfig : jasmine.createSpy('getConfig'),
    track: track !== null && track !== void 0 ? track : jasmine.createSpy('track')
  };
}
export function MockUsageTrackerProvider({
  children,
  cloneSpy,
  getConfigSpy,
  setPropertiesSpy,
  trackSpy
}) {
  const mockTracker = useMemo(() => {
    return createMockUsageTracker({
      clone: cloneSpy,
      getConfig: getConfigSpy,
      setProperties: setPropertiesSpy,
      track: trackSpy
    });
  }, [cloneSpy, getConfigSpy, setPropertiesSpy, trackSpy]);
  return /*#__PURE__*/_jsx(UsageTrackerContext.Provider, {
    value: mockTracker,
    children: children
  });
}